<button class="cursor-pointer m-auto text-action-fg-primary" [matMenuTriggerFor]="afterMenu">
  {{ userInitials }}
</button>
<mat-menu
  #afterMenu="matMenu"
  xPosition="after"
  yPosition="below"
  class="max-w-none min-w-[19.5rem]">
  <div class="disabled-interactive" mat-menu-item>
    <div class="flex gap-050-rem px-050-rem py-075-rem">
      <div
        class="text-action-fg-primary w-250-rem h-250-rem rounded-full bg-action-bg-muted flex justify-center items-center">
        {{ userInitials }}
      </div>
      <div>
        <p class="text-container-fg-default text-label-lg">{{ userFullName }}</p>
        <p class="text-container-fg-muted text-label-md">{{ userEmail }}</p>
      </div>
    </div>
  </div>
  <button (click)="handleLogout()" mat-menu-item>
    <div class="flex gap-050-rem items-center text-action-bg-default px-050-rem">
      <i class="icon_marina_ui_LogoutOutlined text-headline-md"></i>
      <span class="text-label-lg font-medium">Log-out</span>
    </div>
  </button>
</mat-menu>
